import app from 'flarum/forum/app';
import Dropdown from 'flarum/common/components/Dropdown';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import { containsActiveLink, linkGroupItems } from '../utils/linkGroup';
/**
 * A group named by a label. The label goes nowhere on its own, so it is the
 * button that opens the menu.
 */
export default class LabelDropdown extends Dropdown {
  static initAttrs(attrs) {
    const link = attrs.link;
    const title = link.title();
    attrs.label = m("span", {
      className: "LinksButton-title",
      "data-title": title
    }, title);
    attrs.icon = link.icon() || undefined;
    attrs.accessibleToggleLabel ||= extractText(app.translator.trans('fof-links.forum.header.toggle_dropdown_accessible_label', {
      title
    }));
    super.initAttrs(attrs);
    attrs.className = classList(attrs.className, 'LinkDropdown', {
      'LinkDropdown--active': containsActiveLink(link)
    });
    attrs.buttonClassName = classList(attrs.buttonClassName, 'Button Button--link LinksButton', {
      hasIcon: !!attrs.icon
    });
    attrs.menuClassName = 'LinkDropdown-menu';
  }
  view(vnode) {
    return super.view({
      ...vnode,
      children: this.items().toArray()
    });
  }
  items() {
    return linkGroupItems(this.attrs.link);
  }
}
flarum.reg.add('fof-links', 'forum/components/LabelDropdown', LabelDropdown);